module.exports = __webpack_public_path__ + "img/mountains3.eeebe79a.webp";